import { z } from 'zod';
import { PAGINATION, SLUG_PATTERN } from '../constants.js';

export const slugSchema = z
  .string()
  .min(1)
  .max(80)
  .regex(SLUG_PATTERN, 'Must be a lowercase hyphenated slug');

export const paginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(PAGINATION.defaultPage),
  pageSize: z.coerce
    .number()
    .int()
    .min(1)
    .max(PAGINATION.maxPageSize)
    .default(PAGINATION.defaultPageSize),
});

export const seoSchema = z
  .object({
    seoTitle: z.string().max(70).nullable().optional(),
    seoDescription: z.string().max(320).nullable().optional(),
    canonicalUrl: z.string().url().nullable().optional(),
    noindex: z.boolean().optional().default(false),
    ogImageMediaId: z.string().uuid().nullable().optional(),
  })
  .partial();

export type PaginationQuery = z.infer<typeof paginationQuerySchema>;
